var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-modal',_vm._g(_vm._b({staticClass:"onboarding-modal-container",attrs:{"name":"onboarding","hide-close":"","modal-size":"650px"}},'c-modal',_vm.$attrs,false),_vm.$listeners),[_c('onboarding-modal',{on:{"close":_vm.closeModal}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/poi/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63e0f108","hasScoped":true,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/poi/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Login/OnboardingModalContainer.vue
// module id = 2167
// module chunks = 1612